import React from 'react';
import PropTypes from 'prop-types';
import fullName from 'utils/formatters/fullName';
import { useTranslation } from 'react-i18next';
function DriverInfoWindow(props) {
    const { t } = useTranslation();
    const equipment = props.driver.equipment_class
        ? t(props.driver.equipment_class.label)
        : '?';
    const phoneLink = `tel:${props.driver.phone}`;
    return (React.createElement("div", { className: "driver-jobs-popover" },
        React.createElement("p", null,
            React.createElement("strong", null, fullName(props.driver))),
        props.driver.phone && (React.createElement("p", null,
            React.createElement("i", { className: "fa fa-phone" }),
            React.createElement("a", { href: phoneLink }, props.driver.phone))),
        props.carrierName && React.createElement("p", null,
            "Carrier: ",
            props.carrierName),
        React.createElement("p", null,
            "Truck Type: ",
            equipment)));
}
DriverInfoWindow.propTypes = {
    driver: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        carrierName: PropTypes.string,
        equipment_class: PropTypes.shape({
            label: PropTypes.string,
        }),
        phone: PropTypes.string,
        jobs: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
};
export default DriverInfoWindow;
